import React from 'react';

// INPUT ERROR DISPLAY
export type ValidInputErrorParams = {
    err?: string;
    showMsg?: boolean;
};

const ValidInputError = ({ err, showMsg }: ValidInputErrorParams): JSX.Element => {
    const displayMsg = !!err && showMsg;
    return displayMsg ? <span className="valid-input-error">{err}</span> : <></>;
};

export default ValidInputError;
